<template>
    <div>
        <div v-if="loading" class="loading-screen">
            <div class="loading-spinner"></div>
        </div>
        <div v-else>
            <div class="business-profile" v-if="isActive()">
                <a-alert
                    message="Someting is Wrong"
                    description="Any account details not taken, Please check your account information!"
                    type="error"
                    show-icon
                />
            </div>
            <div class="business-profile" v-else>
                <div class="business-profile-details">
                    <div class="profile-image-detail">
                        <div class="profile-image">
                            <img :src="profile.profilePicture" alt="" />
                        </div>
                        <div class="profile-image-description">
                            {{ $t("whatsapp_business_api.profileImageDesc") }}
                        </div>
                    </div>
                    <div class="business-description">
                        <div class="business-description-title">{{ $t("whatsapp_business_api.bussinesDesciption") }}</div>
                        <div class="business-description-info">
                            {{ $t("whatsapp_business_api.descOfWork") }}
                        </div>
                        <div class="business-description-input">
                            <a-textarea v-model="profile.profile.desc" :auto-size="{ minRows: 5, maxRows: 5 }" />
                        </div>
                    </div>
                    <div class="business-website-input">
                        <div class="business-website-input-title">Business Website 1</div>
                        <a-input v-model="profile.profile.website1" :auto-size="{ minRows: 5, maxRows: 5 }" />
                    </div>
                    <div class="business-website-input">
                        <div class="business-website-input-title">Business Website 2</div>
                        <a-input v-model="profile.profile.website2" :auto-size="{ minRows: 5, maxRows: 5 }" />
                    </div>
                    <div class="business-email-input">
                        <div class="business-email-input-title">{{$t("calendar.emailAddress")}}</div>
                        <a-input v-model="profile.profile.profileEmail" :auto-size="{ minRows: 5, maxRows: 5 }" />
                    </div>
                    <div class="business-about-input">
                        <div class="business-about-input-title">{{ $t("calendar.about") }} *</div>
                        <a-textarea v-model="profile.about" :auto-size="{ minRows: 5, maxRows: 5 }" />
                    </div>
                </div>
                <div class="business-profile-information">
                    <div class="business-profile-information-status">
                        <div class="business-profile-information-status-title">{{$t("whatsapp_business_api.wabaOverview")}}</div>
                        <div class="business-profile-information-status-details">
                            <div class="business-profile-information-status-details-card">
                                <div class="business-profile-information-status-details-card-status">
                                    <div
                                        class="business-profile-information-status-details-card-status-badge"
                                        :status="accountStatus[profile.wabaInfo.accountStatus].color"
                                    ></div>
                                    <div class="business-profile-information-status-details-card-status-name">
                                        {{ accountStatus[profile.wabaInfo.accountStatus].text }}
                                    </div>
                                </div>
                                <div class="business-profile-information-status-details-card-title">{{$t("whatsapp_business_api.accountStatus")}}</div>
                            </div>
                            <div class="business-profile-information-status-details-card">
                                <div class="business-profile-information-status-details-card-status">
                                    <div
                                        class="business-profile-information-status-details-card-status-badge"
                                        :status="phoneQuality[profile.wabaInfo.phoneQuality].color"
                                    ></div>
                                    <div class="business-profile-information-status-details-card-status-name">
                                        {{ phoneQuality[profile.wabaInfo.phoneQuality].text }}
                                    </div>
                                </div>
                                <div class="business-profile-information-status-details-card-title">{{$t("whatsapp_business_api.phoneQuality")}}</div>
                            </div>

                            <div class="business-profile-information-status-details-card">
                                <div class="business-profile-information-status-details-card-status">
                                    <div
                                        class="business-profile-information-status-details-card-status-badge"
                                        status="SUCCESS"
                                    ></div>
                                    <div class="business-profile-information-status-details-card-status-name">
                                        {{ (profile.wabaInfo.messagingLimit || "").split("_")[1] }}
                                        <span> {{ $t("whatsapp_business_api.customersOrDay") }}</span>
                                    </div>
                                </div>
                                <div class="business-profile-information-status-details-card-title">
                                    {{ $t("whatsapp_business_api.messagingLimit") }}
                                </div>
                            </div>
                            <div class="business-profile-information-status-details-card">
                                <div class="business-profile-information-status-details-card-status">
                                    <div
                                        class="business-profile-information-status-details-card-status-badge"
                                        :status="canSendMessage[profile.wabaInfo.canSendMessage].color"
                                    ></div>
                                    <div class="business-profile-information-status-details-card-status-name">
                                        {{ canSendMessage[profile.wabaInfo.canSendMessage].text }}
                                    </div>
                                </div>
                                <div class="business-profile-information-status-details-card-title">
                                     {{ $t("whatsapp_business_api.canSendMessage") }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="business-profile-information-address">
                        <div class="official-details">
                            <div class="official-details-title">{{$t("whatsapp_business_api.officialDetails")}}</div>
                            <div class="official-details-description">
                                {{$t("whatsapp_business_api.officialDetailsDesc")}}
                            </div>
                            <div class="official-details-form">
                                <div class="official-details-form-item">
                                    <div class="official-details-form-item-title">{{$t("whatsapp_business_api.addressLine")}} 1</div>
                                    <div class="official-details-form-item-input">
                                        <a-input
                                            :value="profile.profile.addLine1"
                                            :auto-size="{ minRows: 5, maxRows: 5 }"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="official-details-form-item">
                                    <div class="official-details-form-item-title">{{$t("whatsapp_business_api.addressLine")}} 2</div>
                                    <div class="official-details-form-item-input">
                                        <a-input
                                            :value="profile.profile.addLine2"
                                            :auto-size="{ minRows: 5, maxRows: 5 }"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="official-details-form-item">
                                    <div class="official-details-form-item-title">{{ $t("message.city") }}</div>
                                    <div class="official-details-form-item-input">
                                        <a-input
                                            :value="profile.profile.city"
                                            :auto-size="{ minRows: 5, maxRows: 5 }"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="official-details-form-item">
                                    <div class="official-details-form-item-title">{{$t("whatsapp_business_api.stateIfApplic")}}</div>
                                    <div class="official-details-form-item-input">
                                        <a-input
                                            :value="profile.profile.state"
                                            :auto-size="{ minRows: 5, maxRows: 5 }"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="official-details-form-item">
                                    <div class="official-details-form-item-title">{{$t("whatsapp_business_api.zipCodeOrPostCode")}}</div>
                                    <div class="official-details-form-item-input">
                                        <a-input
                                            :value="profile.profile.pinCode"
                                            :auto-size="{ minRows: 5, maxRows: 5 }"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="official-details-form-item">
                                    <div class="official-details-form-item-title">{{$t("whatsapp_business_api.selectCountry")}}</div>
                                    <div class="official-details-form-item-input">
                                        <a-input
                                            :value="profile.profile.country"
                                            :auto-size="{ minRows: 5, maxRows: 5 }"
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div class="official-details-form-item">
                                    <div class="official-details-form-item-title">{{$t("whatsapp_business_api.selectBussVertical")}}*</div>
                                    <div class="official-details-form-item-input">
                                        <a-select :value="profile.profile.vertical" style="width: 100%" disabled>
                                            <a-select-option
                                                v-for="vertical of verticals"
                                                :value="vertical"
                                                :key="vertical"
                                            >
                                                {{ vertical }}
                                            </a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="business-submit">
                        <SupsisButton primary @click="saveProfile" :disabled="isSaving">
                            <template v-if="!isSaving"> {{$t("whatsapp_business_api.saveInfo")}}</template>
                            <template v-else>
                                <div class="button-loading-spinner"></div>
                            </template>
                        </SupsisButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import log2 from "../../../../utils/log2";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import SupsisButton from "../../Settings/components/SupsisButton.vue";

const log = log2("BusinessProfile");
export default {
    name: "BusinessProfile",
    components: { SupsisButton },
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            isSaving: false,
            profile: {},
            clone: _.cloneDeep(this.value),
            subscribers: [],
            verticals: [
                "Travel and Transportation",
                "Event Planning and Service",
                "Entertainment",
                "Beauty, Spa and Salon",
                "Clothing and Apparel",
                "Finance and Banking",
                "Automotive",
                "Professional Services",
                "Restaurant",
                "Education",
                "Medical and Health",
                "Food and Grocery",
                "Public Service",
                "Non-profit",
                "Shopping and Retail",
                "Hotel and Lodging",
                "Other",
            ],
            // ACTIVE | BANNED
            accountStatus: {
                ACTIVE: {
                    color: "SUCCESS",
                    text: this.$t("whatsapp_business_api.active"),
                },
                BANNED: {
                    color: "DANGER",
                    text: this.$t("whatsapp_business_api.banned"),
                },
            },
            phoneQuality: {
                UNKNOWN: {
                    color: "DANGER",
                    text: this.$t("whatsapp_business_api.unknown"),
                },
                RED: {
                    color: "DANGER",
                   text: this.$t("whatsapp_business_api.low"),
                },
                YELLOW: {
                    color: "WARNING",
                    text: this.$t("whatsapp_business_api.medium"),
                },
                GREEN: {
                    color: "SUCCESS",
                   text: this.$t("whatsapp_business_api.high"),
                },
            },
            dockerStatus: {
                CONNECTED: {
                    color: "SUCCESS",
                   text: this.$t("whatsapp_business_api.connected"),
                },
                DISCONNECTED: {
                    color: "DANGER",
                    text: this.$t("whatsapp_business_api.disconnected"),
                },
                FLAGGED: {
                    color: "DANGER",
                   text: this.$t("whatsapp_business_api.flagged"),
                },
                PENDING: {
                    color: "WARNING",
                    text: this.$t("whatsapp_business_api.pending"),
                },
                RESTRICTED: {
                    color: "DANGER",
                    text: this.$t("whatsapp_business_api.restricted"),
                },
                UNKNOWN: {
                    color: "DANGER",
                   text: this.$t("whatsapp_business_api.unknown"),
                },
            },
            canSendMessage: {
                AVAILABLE: {
                    color: "SUCCESS",
                     text: this.$t("whatsapp_business_api.available"),
                },
                LIMITED: {
                    color: "WARNING",
                     text: this.$t("whatsapp_business_api.limited"),
                },
                BLOCKED: {
                    color: "DANGER",
                    text:  this.$t("whatsapp_business_api.blocked"),
                },
            },
        };
    },
    mounted() {
        sendSocketMessage("whatsapp profile", {
            siteId: this.value.siteId,
            channelId: this.value._id,
        });
        const profile = socketMessageStream.subscribe((message) => {
            if (message.cmd === "whatsapp_business_profile") {
                if (message.data.channelId === this.value._id) {
                    this.profile = message.data.profile;
                    this.loading = false;
                }
            } else if (message.cmd === "whatsapp_business_profile_updated") {
                if (message.data) {
                    this.$notification.success({
                        message:  this.$t("whatsapp_business_api.success"),
                        description: this.$t("whatsapp_business_api.successDesc"),
                    });
                }
                this.isSaving = false;
            }
        });
        this.subscribers.push(() => {
            profile.unsubscribe();
        });
    },
    beforeDestroy() {
        this.subscribers.forEach((fn) => fn());
    },
    methods: {
        async saveProfile() {
            this.isSaving = true;
            await sendSocketMessage("whatsapp update-profile", {
                siteId: this.value.siteId,
                channelId: this.value._id,
                payload: {
                    profile: this.profile.profile,
                    about: this.profile.about,
                },
            });
        },
        isActive() {
            return !this.$_.get(this.profile, "wabaInfo.accountStatus");
        },
        getStatusColor(type) {},
    },
    watch: {
        clone: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.value);
                    if (isChanged) {
                        log("clone changed=>", val);
                        this.$emit("input", val);
                    }
                }
            },
            deep: true,
        },
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    log("value changed=>", val);
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
.loading-screen {
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);
}

.loading-spinner {
    width: 50px;
    height: 50px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.business-profile {
    width: 100%;
    display: flex;
    padding: 20px;
    gap: 20px;
    flex-wrap: nowrap;

    input,
    textarea {
        resize: none;

        &:focus {
            border-color: var(--color-icon-primary-default);
            box-shadow: 0 0 0 2px var(--color-bg-active);
        }

        &:hover {
            border-color: var(--color-icon-primary-default);
        }
    }

    input {
        height: 45px;
    }

    &-details {
        width: 400px;
        min-width: 400px;
        background: white;
        border: 1px solid var(--border-neutral-default);
        box-shadow: 0 3px 10px rgba(40, 75, 117, 0.03);
        border-radius: 12px;
        padding: 15px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .profile-image-detail {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .profile-image {
            overflow: hidden;
            width: 100px;
            height: 100px;
            border-radius: 50%;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .profile-image-description {
            font-size: 13px;
            align-items: center;
        }

        .business-description {
            &-title {
                font-size: 14px;
                font-weight: bold;
            }

            &-info {
                font-size: 12px;
                font-weight: lighter;
            }
        }

        .business-website-input {
            &-title {
                font-size: 14px;
                font-weight: bold;
            }
        }

        .business-email-input {
            &-title {
                font-size: 14px;
                font-weight: bold;
            }
        }

        .business-about-input {
            &-title {
                font-size: 14px;
                font-weight: bold;
            }
        }
    }

    &-information {
        width: calc(100% - 400px);
        display: flex;
        flex-direction: column;
        gap: 20px;
        min-width: 400px;

        &-status {
            width: 100%;
            background: white;
            border: 1px solid var(--border-neutral-default);
            box-shadow: 0 3px 10px rgba(40, 75, 117, 0.03);
            border-radius: 12px;
            padding: 15px;
            display: flex;
            flex-direction: column;
            gap: 10px;

            &-title {
                font-size: 18px;
                font-weight: bold;
            }

            &-details {
                width: 100%;
                display: flex;
                align-items: center;
                gap: 5px;
                flex-wrap: wrap;

                &-card {
                    background: white;
                    border: 1px solid var(--border-neutral-default);
                    box-shadow: 0 3px 10px rgba(40, 75, 117, 0.03);
                    border-radius: 12px;
                    padding: 15px;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    width: 24%;
                    min-width: 220px;

                    &-status {
                        display: flex;
                        align-items: center;
                        gap: 5px;

                        &-badge {
                            height: 12px;
                            width: 12px;
                            border-radius: 50%;

                            &[status="UNKNOWN"] {
                                background: #ff4d4f;
                            }

                            &[status="SUCCESS"] {
                                background: #008d35;
                            }
                            &[status="DANGER"] {
                                background: #ff4d4f;
                            }
                            &[status="WARNING"] {
                                background: #fa8c16;
                            }
                        }

                        &-name {
                            font-size: 20px;
                            font-weight: bold;

                            span {
                                font-size: 14px;
                                font-weight: lighter;
                            }
                        }
                    }

                    &-title {
                        font-size: 18px;
                    }
                }
            }
        }

        &-address {
            width: 100%;
            background: white;
            border: 1px solid var(--border-neutral-default);
            box-shadow: 0 3px 10px rgba(40, 75, 117, 0.03);
            border-radius: 12px;
            padding: 15px;

            .official-details {
                display: flex;
                flex-direction: column;
                gap: 10px;

                &-title {
                    font-size: 14px;
                    font-weight: bold;
                }

                &-description {
                    font-size: 12px;
                    font-weight: lighter;
                }

                &-form {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-wrap: wrap;

                    &-item {
                        width: 30%;
                        min-width: 200px;

                        &-title {
                            font-size: 14px;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }

    &-submit {
        position: relative;
        width: max-content;
        height: max-content;

        button {
            min-width: 150px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.button-loading-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid #f3f3f3;
    border-top: 2px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
